<div class="ced-cancelado-msg">
  <mat-icon class="material-symbols-outlined ced-cancelado-icon">block</mat-icon>
  <div>
    <div class="ced-cancelado-title">Card cancelado</div>
    <div class="ced-cancelado-sub">Estado final. Nenhuma ação operacional está disponível nesta etapa.</div>
  </div>
</div>

<div class="section-title">
  <mat-icon>cancel</mat-icon>
  <span>Motivo do cancelamento</span>
</div>

<div class="ced-cancelado-justificativa-wrap">
  <div class="ced-cancelado-info-label">Justificativa registrada</div>
  <div class="ced-cancelado-justificativa">
    {{ canceladoMotivo || 'Nenhuma justificativa registrada.' }}
  </div>
</div>

<div class="ced-cancelado-info-grid">
  <div class="ced-cancelado-info">
    <div class="ced-cancelado-info-label">Etapa de origem</div>
    <div class="ced-cancelado-info-value">{{ canceladoEtapaOrigem }}</div>
  </div>
  <div class="ced-cancelado-info">
    <div class="ced-cancelado-info-label">Cancelado por</div>
    <div class="ced-cancelado-info-value">{{ canceladoPor }}</div>
  </div>
  <div class="ced-cancelado-info">
    <div class="ced-cancelado-info-label">Data de cancelamento</div>
    <div class="ced-cancelado-info-value">{{ canceladoData || 'Data não registrada' }}</div>
  </div>
  <div class="ced-cancelado-info">
    <div class="ced-cancelado-info-label">Referência</div>
    <div class="ced-cancelado-info-value ced-mono">{{ canceladoReferencia }}</div>
  </div>
</div>

@if (notas.length) {
<section class="ced-cancelado-notas" aria-label="Nota fiscal">
  <div class="ced-cancelado-notas-titulo">
    <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
    <h3>Nota fiscal</h3>
  </div>
  <p class="ced-cancelado-notas-apoio">A NF liberada volta para a gaveta e pode ser vinculada a outro pedido.</p>

  <div class="ced-cancelado-notas-lista">
    @for (item of notas; track item.idNFeEntrada) {
    <div class="ced-cancelado-nota">
      <mat-icon class="material-symbols-outlined ced-cancelado-nota-icone">receipt_long</mat-icon>
      <span class="ced-cancelado-nota-texto">
        @if (item.nota; as nota) {
        <b>NF-e {{ nota.numero || '—' }}/{{ nota.serie || '—' }}</b>
        @if (nota.nomeEmitente || nota.cnpjEmitente) { · {{ nota.nomeEmitente || nota.cnpjEmitente }} }
        } @else {
        <b>NF-e #{{ item.idNFeEntrada }}</b>
        }
      </span>
      @if (item.isLiberada) {
      <span class="status-badge badge-cinza ced-cancelado-nota-pilula">Liberada para a gaveta</span>
      } @else {
      <span class="status-badge badge-verde ced-cancelado-nota-pilula">Continua vinculada</span>
      }
      <button mat-button type="button" class="btn-section ced-cancelado-nota-abrir" (click)="abrirNota(item.idNFeEntrada)"
        matTooltip="Abrir a nota em nova aba">
        <mat-icon class="material-symbols-outlined">open_in_new</mat-icon> Abrir nota
      </button>
    </div>
    }
  </div>
</section>
}

<app-alert-card type="neutral" icon="lock" title="Card bloqueado para edição.">
  Produtos, fornecedor e dados da solicitação permanecem somente leitura.
</app-alert-card>
